function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 514,
  width: 514,
  y: -1,
  x: -1
}));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
  id: "svg_1",
  fill: "#4F4F4F",
  d: "m4.2002,4.2002l15.6,0l0,15.6l-15.6,0l0,-15.6zm-1,0c0,-0.55229 0.44771,-1 1,-1l15.6,0c0.5523,0 1,0.44771 1,1l0,15.6c0,0.5523 -0.4477,1 -1,1l-15.6,0c-0.55229,0 -1,-0.4477 -1,-1l0,-15.6z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.e2b86d60f5209d01c8644e9aab089729.svg";
export { ForwardRef as ReactComponent };